<template>
<div class="mod-config">
    <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()">

        <el-form-item label="" prop="userId">
            <el-dict-select placeholder="任课老师" v-model="dataForm.userId" type="teacherSelects" :props="{ label: 'realName', value: 'userId' }"></el-dict-select>
        </el-form-item>
        <el-form-item label="" prop="recordDate">
            <el-date-picker v-model="recordDate" type="daterange" value-format="yyyy-MM-dd" range-separator="-" start-placeholder="开始日期" end-placeholder="结束日期">
            </el-date-picker>
        </el-form-item>
        <el-form-item>
            <el-dict-select v-if="manageOrgIdFlag()" placeholder="选择机构" v-model="dataForm.orgId" type="orgList"></el-dict-select>
        </el-form-item>
        <el-form-item>
            <el-button @click="rgetDataList()">查询</el-button>
        </el-form-item>
    </el-form>
    <el-row style="margin-bottom: 1rem;">
        <!--<el-col>
            <el-button type="info" @click="excel" v-if="isAuth('sys:studentClass:export')">导出<i class="el-icon-download"></i></el-button>
        </el-col>-->
    </el-row>
    <el-table :data="dataList" border v-loading="dataListLoading" @selection-change="selectionChangeHandle" style="width: 100%">
        <el-table-column type="index" header-align="center" align="center" label="序号" :index="indexMethod" width="50">
        </el-table-column>
        <el-table-column prop="teacherName" header-align="center" align="center" label="任课老师">
        </el-table-column>
        <el-table-column v-if="manageOrgIdFlag()" prop="orgName" header-align="center" align="center" label="所属机构">
        </el-table-column>
        <el-table-column prop="nums" header-align="center" align="center" label="总排课数">
        </el-table-column>
        <el-table-column prop="done" header-align="center" align="center" label="上课数">
        </el-table-column>
        <el-table-column prop="lack" header-align="center" align="center" label="缺课数">
        </el-table-column>
        <el-table-column prop="wait" header-align="center" align="center" label="未签到数">
        </el-table-column>
        <el-table-column prop="settlement" header-align="center" align="center" label="结算数">
        </el-table-column>
        <el-table-column prop="kp" header-align="center" align="center" label="课评数">
        </el-table-column>
        <el-table-column prop="percentByDone" header-align="center" align="center" label="上课率">
        </el-table-column>
        <el-table-column prop="percentBySettlement" header-align="center" align="center" label="结算率">
        </el-table-column>
        <el-table-column prop="percentByKp" header-align="center" align="center" label="课评率">
        </el-table-column>
        
        
    </el-table>
    <el-pagination @size-change="sizeChangeHandle" @current-change="currentChangeHandle" :current-page="pageIndex" :page-sizes="[10, 20, 50, 100]" :page-size="pageSize" :total="totalPage" layout="total, sizes, prev, pager, next, jumper">
    </el-pagination>
    <!-- 弹窗, 新增 / 修改 -->
    <add-or-update v-if="addOrUpdateVisible" ref="addOrUpdate" @refreshDataList="getDataList"></add-or-update>
</div>
</template>

<script>
import AddOrUpdate from "./classRecord-add-or-update";

export default {
    data() {
        return {
            dataForm: {
                courseName: "",
                userId: "",
                orgId: ""
            },
            recordDate: [],
            dataList: [],
            pageIndex: 1,
            pageSize: 10,
            totalPage: 0,
            dataListLoading: false,
            dataListSelections: [],
            addOrUpdateVisible: false,
        };
    },
    computed: {
        startDate() {
            return this.recordDate && this.recordDate.length ?
                this.recordDate[0] :
                "";
        },
        endDate() {
            return this.recordDate && this.recordDate.length ?
                this.recordDate[1] :
                "";
        },
    },
    components: {
        AddOrUpdate,
    },
    created() {
        this.recordDate[0]=this.formatDate1(new Date())
        this.recordDate[1]=this.formatDate2(new Date())
        this.getDataList();
        this.doSearch();
    },
    methods: {
        formatDate2(date) {
        var d = new Date(date),
            month = '' + (d.getMonth() + 1),
            day = '' + d.getDate(),
            year = d.getFullYear();
        if (month.length < 2)
            month = '0' + month;
        if (day.length < 2)
            day = '0' + day;
        return [year, month, day].join('-');
        },
        formatDate1(date) {
        var d = new Date(date),
            month = '' + (d.getMonth()),
            day = '' + d.getDate(),
            year = d.getFullYear();
        if (month.length < 2)
            month = '0' + month;
        if (day.length < 2)
            day = '0' + day;
        return [year, month, day].join('-');
        },
      
        indexMethod(index) {
            return (this.pageIndex - 1) * this.pageSize + index + 1;
        },
        // 获取数据列表
        getDataList() {
            this.dataListLoading = true;
            this.$http({
                url: this.$http.adornUrl("course/record/list"),
                method: "get",
                params: this.$http.adornParams({
                    page: this.pageIndex,
                    limit: this.pageSize,
                    ...this.dataForm,
                    startDate: this.startDate,
                    endDate: this.endDate,
                }),
            }).then(({
                data
            }) => {
                if (data && data.code === 0) {
                    this.dataList = data.page.list;
                    this.totalPage = data.page.totalCount;
                } else {
                    this.dataList = [];
                    this.totalPage = 0;
                }
                this.dataListLoading = false;
            });
        },
        doSearch() {
            let that = this;
            document.onkeypress = function (e) {
                let keycode = document.all ? event.keyCode : e.which;
                if (keycode == 13) {
                    that.rgetDataList();
                }
            }
        },
        // 每页数
        sizeChangeHandle(val) {
            this.pageSize = val;
            this.pageIndex = 1;
            this.getDataList();
        },
        // 当前页
        currentChangeHandle(val) {
            this.pageIndex = val;
            this.getDataList();
        },
        // 多选
        selectionChangeHandle(val) {
            this.dataListSelections = val;
        },
        // 新增 / 修改
        addOrUpdateHandle(id) {
            this.addOrUpdateVisible = true;
            this.$nextTick(() => {
                this.$refs.addOrUpdate.init(id);
            });
        },
        // 删除
        deleteHandle(id) {
            this.$confirm(`确定删除该排课记录?`, "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            }).then(() => {
                this.$http({
                    url: this.$http.adornUrl("course/record/delete"),
                    method: "delete",
                    data: id,
                }).then(({
                    data
                }) => {
                    if (data && data.code === 0) {
                        this.$message({
                            message: "删除成功",
                            type: "success",
                        });
                        this.getDataList();
                    } else {
                        this.$message.error(data.msg);
                    }
                });
            });
        }
    },
};
</script>
